export const getQuizReportTableHeaders = () =>
	Object.freeze(['No', 'Version', 'Compare Source', 'Compare To', 'Result']);
